// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"magnifier_wrapper__XBEE7"};